<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | Health Extension Worker Dashboard</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="HEW Dashboard - Community Health Services" name="description" />
    <meta content="CBHI System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">HEW Dashboard</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Health Extension</a></li>
                    <li class="breadcrumb-item active">Dashboard</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Alerts -->
          <div v-if="alert.success" class="alert alert-success" role="alert">
            {{message}}
          </div>
          <div v-if="alert.info" class="alert alert-primary" role="alert">
            {{message}}
          </div>
          <div v-if="alert.failed" class="alert alert-danger" role="alert">
            {{message}}
          </div>

          <!-- Dashboard Statistics -->
          <div class="row">
            <!-- Total Households -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Households</p>
                      <h5 class="mb-0">{{ statistics.total_households || 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-home"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Members -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Members</p>
                      <h5 class="mb-0">{{ statistics.total_members || 0 }}</h5>
                      <p class="text-success mb-0 mt-1">
                        <small>CBHI: {{ statistics.cbhi_members || 0 }}</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-group"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Today's Visits -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Today's Visits</p>
                      <h5 class="mb-0">{{ statistics.visits_today || 0 }}</h5>
                      <p class="text-muted mb-0 mt-1">
                        <small>This Month: {{ statistics.visits_month || 0 }}</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-calendar-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Active Pregnancies -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Active Pregnancies</p>
                      <h5 class="mb-0">{{ statistics.active_pregnancies || 0 }}</h5>
                      <p class="text-muted mb-0 mt-1">
                        <small>Under 5: {{ statistics.under_five_children || 0 }}</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="bx bx-heart"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Today's Schedule -->
            <div class="col-lg-6">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Today's Schedule</h5>
                  <button @click="showScheduleModal = true" class="btn btn-sm btn-primary">
                    <i class="bx bx-plus"></i> Add Task
                  </button>
                </div>
                <div class="card-body">
                  <div v-if="todaySchedule.length === 0" class="text-center py-4">
                    <i class="bx bx-calendar-x text-muted" style="font-size: 48px;"></i>
                    <p class="mt-3 text-muted">No scheduled tasks for today</p>
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table align-middle mb-0">
                      <tbody>
                      <tr v-for="task in todaySchedule" :key="task.schedule_id"
                          class="cursor-pointer" @click="viewHousehold(task.household_id)">
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-3">
                              <div :class="'avatar-title rounded-circle text-white ' + getPriorityColor(task.priority)">
                                <i class="bx bx-home"></i>
                              </div>
                            </div>
                            <div>
                              <h6 class="mb-0">{{ task.household_number }}</h6>
                              <small class="text-muted">{{ task.household_head }}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span :class="'badge ' + getPriorityBadge(task.priority)">
                            {{ task.priority }}
                          </span>
                        </td>
                        <td>
                          <small>{{ task.scheduled_time || 'Anytime' }}</small>
                        </td>
                        <td class="text-end">
                          <button @click.stop="completeTask(task)" class="btn btn-sm btn-success">
                            <i class="bx bx-check"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Recent Alerts -->
            <div class="col-lg-6">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="mb-0">Health Alerts</h5>
                </div>
                <div class="card-body">
                  <div v-if="alerts.length === 0" class="text-center py-4">
                    <i class="bx bx-bell-off text-muted" style="font-size: 48px;"></i>
                    <p class="mt-3 text-muted">No active alerts</p>
                  </div>
                  <div v-else>
                    <div v-for="alert in alerts" :key="alert.member_id"
                         class="d-flex align-items-center mb-3 p-3 border rounded cursor-pointer"
                         :class="{'border-danger': alert.priority === 'high'}"
                         @click="handleAlert(alert)">
                      <div class="flex-shrink-0">
                        <i :class="'bx ' + getAlertIcon(alert.alert_type) + ' text-' + getAlertColor(alert.priority)"
                           style="font-size: 24px;"></i>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h6 class="mb-1">{{ alert.message }}</h6>
                        <small class="text-muted">
                          Household: {{ alert.household_id }}
                        </small>
                      </div>
                      <div class="flex-shrink-0">
                        <i class="bx bx-chevron-right text-muted"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Quick Actions -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="mb-0">Quick Actions</h5>
                </div>
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-md-3 col-sm-6">
                      <button @click="startNewVisit" class="btn btn-primary w-100 py-3">
                        <i class="bx bx-home-circle d-block mb-2" style="font-size: 24px;"></i>
                        Start Household Visit
                      </button>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <button @click="showImmunizationModal = true" class="btn btn-success w-100 py-3">
                        <i class="bx bx-injection d-block mb-2" style="font-size: 24px;"></i>
                        Record Immunization
                      </button>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <button @click="showPregnancyModal = true" class="btn btn-warning w-100 py-3">
                        <i class="bx bx-female d-block mb-2" style="font-size: 24px;"></i>
                        Register Pregnancy
                      </button>
                    </div>
                    <div class="col-md-3 col-sm-6">
                      <button @click="showReferralModal = true" class="btn btn-danger w-100 py-3">
                        <i class="bx bx-transfer d-block mb-2" style="font-size: 24px;"></i>
                        Create Referral
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Recent Activities -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Recent Activities</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <h6 class="mb-3">Today's Services</h6>
                      <div class="mb-3">
                        <div class="d-flex justify-content-between mb-2">
                          <span>Vaccinations</span>
                          <strong>{{ statistics.vaccinations_today || 0 }}</strong>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                          <span>ANC Visits</span>
                          <strong>{{ dailyServices.anc_visits || 0 }}</strong>
                        </div>
                        <div class="d-flex justify-content-between mb-2">
                          <span>Health Education</span>
                          <strong>{{ dailyServices.education_sessions || 0 }}</strong>
                        </div>
                        <div class="d-flex justify-content-between">
                          <span>Referrals</span>
                          <strong>{{ dailyServices.referrals || 0 }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6 class="mb-3">Coverage This Month</h6>
                      <div class="mb-3">
                        <p class="mb-2">Households Visited</p>
                        <div class="progress" style="height: 20px;">
                          <div class="progress-bar" role="progressbar"
                               :style="{width: getCoveragePercentage() + '%'}"
                               :aria-valuenow="getCoveragePercentage()"
                               aria-valuemin="0" aria-valuemax="100">
                            {{ getCoveragePercentage() }}%
                          </div>
                        </div>
                        <small class="text-muted">
                          {{ statistics.households_visited_month || 0 }} of {{ statistics.total_households || 0 }}
                        </small>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <h6 class="mb-3">Model Households</h6>
                      <div class="text-center">
                        <h2 class="mb-0 text-primary">{{ statistics.model_households || 0 }}</h2>
                        <p class="text-muted mb-0">Certified Model Households</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Import Modal Components -->
      <NewVisitModal
          v-if="showNewVisitModal"
          @close="showNewVisitModal = false"
          @started="onVisitStarted"
      />

      <ImmunizationModal
          v-if="showImmunizationModal"
          @close="showImmunizationModal = false"
          @recorded="onImmunizationRecorded"
      />

      <PregnancyRegistrationModal
          v-if="showPregnancyModal"
          @close="showPregnancyModal = false"
          @registered="onPregnancyRegistered"
      />

      <ReferralModal
          v-if="showReferralModal"
          @close="showReferralModal = false"
          @created="onReferralCreated"
      />

      <ScheduleTaskModal
          v-if="showScheduleModal"
          @close="showScheduleModal = false"
          @created="onTaskScheduled"
      />

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© CBHI</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Ministry of Health - Ethiopia
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import NewVisitModal from "@/components/hew/modals/NewVisitModal.vue";
import ImmunizationModal from "@/components/hew/modals/ImmunizationModal.vue";
import PregnancyRegistrationModal from "@/components/hew/modals/PregnancyRegistrationModal.vue";
import ReferralModal from "@/components/hew/modals/ReferralModal.vue";
import ScheduleTaskModal from "@/components/hew/modals/ScheduleTaskModal.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "HEWDashboard",
  components: {
    NavigationBar,
    NewVisitModal,
    ImmunizationModal,
    PregnancyRegistrationModal,
    ReferralModal,
    ScheduleTaskModal
  },
  data() {
    return {
      // Loading states
      loading: false,

      // Dashboard data
      statistics: {},
      todaySchedule: [],
      alerts: [],
      dailyServices: {},

      // UI States
      showNewVisitModal: false,
      showImmunizationModal: false,
      showPregnancyModal: false,
      showReferralModal: false,
      showScheduleModal: false,

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    };
  },

  computed: {
    getCoveragePercentage() {
      return () => {
        if (!this.statistics.total_households || this.statistics.total_households === 0) return 0;
        const visited = this.statistics.households_visited_month || 0;
        const total = this.statistics.total_households;
        return Math.round((visited / total) * 100);
      };
    }
  },

  mounted() {

    this.loadDashboard();
  },

  methods: {

    checkAuth() {
      const token = localStorage.getItem("authToken");
      const userRole = sessionStorage.getItem("userRoleId");

      if (!token) {
        router.push('/login');
        return;
      }

      // Check if user is HEW (role_id = 38)
      if (userRole !== '38') {
        this.showAlert('failed', 'Access denied. HEW role required.');
        router.push('/dashboard');
      }
    },

    async loadDashboard() {
      this.loading = true;

      const data = {
        "function": "getHEWDashboard"
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.statistics = res.data.data.statistics || {};
          this.todaySchedule = res.data.data.todaySchedule || [];
          this.alerts = res.data.data.alerts || [];

          // Calculate daily services
          this.calculateDailyServices();
        } else {
          this.showAlert('failed', res.data.message || 'Failed to load dashboard');
        }
      } catch (e) {
        console.error("Failed to load dashboard:", e);
        this.showAlert('failed', 'Failed to load dashboard data');
      } finally {
        this.loading = false;
      }
    },

    calculateDailyServices() {
      // This would normally come from the API
      this.dailyServices = {
        anc_visits: Math.floor(Math.random() * 5),
        education_sessions: Math.floor(Math.random() * 3),
        referrals: Math.floor(Math.random() * 2)
      };
    },

    startNewVisit() {
      this.showNewVisitModal = true;
    },

    async completeTask(task) {
      const data = {
        "function": "updateWorkSchedule",
        "scheduleId": task.schedule_id,
        "status": "completed"
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.showAlert('success', 'Task marked as completed');
          await this.loadDashboard();
        } else {
          this.showAlert('failed', res.data.message || 'Failed to complete task');
        }
      } catch (e) {
        console.error("Failed to complete task:", e);
        this.showAlert('failed', 'Failed to complete task');
      }
    },

    viewHousehold(householdId) {
      router.push(`/hew/households/${householdId}`);
    },

    handleAlert(alert) {
      if (alert.alert_type === 'vaccination') {
        router.push(`/hew/members/${alert.member_id}/immunizations`);
      } else if (alert.alert_type === 'pregnancy') {
        router.push(`/hew/members/${alert.member_id}/pregnancy`);
      } else {
        router.push(`/hew/households/${alert.household_id}`);
      }
    },

    // Modal callbacks
    onVisitStarted(visitData) {
      this.showNewVisitModal = false;
      this.showAlert('success', 'Visit started successfully');
      router.push(`/hew/visits/${visitData.visitId}`);
    },

    onImmunizationRecorded() {
      this.showImmunizationModal = false;
      this.showAlert('success', 'Immunization recorded successfully');
      this.loadDashboard();
    },

    onPregnancyRegistered() {
      this.showPregnancyModal = false;
      this.showAlert('success', 'Pregnancy registered successfully');
      this.loadDashboard();
    },

    onReferralCreated() {
      this.showReferralModal = false;
      this.showAlert('success', 'Referral created successfully');
      this.loadDashboard();
    },

    onTaskScheduled() {
      this.showScheduleModal = false;
      this.showAlert('success', 'Task scheduled successfully');
      this.loadDashboard();
    },

    // Utility methods
    getPriorityColor(priority) {
      const colors = {
        'high': 'bg-danger',
        'medium': 'bg-warning',
        'low': 'bg-primary'
      };
      return colors[priority] || 'bg-secondary';
    },

    getPriorityBadge(priority) {
      const badges = {
        'high': 'badge-soft-danger',
        'medium': 'badge-soft-warning',
        'low': 'badge-soft-primary'
      };
      return badges[priority] || 'badge-soft-secondary';
    },

    getAlertIcon(type) {
      const icons = {
        'vaccination': 'bx-injection',
        'pregnancy': 'bx-female',
        'disease': 'bx-plus-medical',
        'malnutrition': 'bx-heart'
      };
      return icons[type] || 'bx-error';
    },

    getAlertColor(priority) {
      return priority === 'high' ? 'danger' : 'warning';
    },

    // Alert methods
    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    }
  }
};
</script>

<style scoped>
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  background-color: #f8f9fa;
}

.progress {
  background-color: #e9ecef;
}

.badge-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18);
}

.badge-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.18);
}

.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
}
</style>